import axios from 'axios';
import envConfig from '@/config';
import http from './http';
import logo from '../assets/images/icon-logo@3x.png';
import { postToken } from '@/utils';

const baseURL = envConfig[`VUE_APP_${envConfig.env.toUpperCase()}_BASE_URL`];

// 微信签名
export const homeJssdkSignApi = (options = {}) => {
  // 获取签名url
  const { iosHref, isApple } = window.app;
  const href = isApple ? iosHref : window.location.href;

  const defaults = {
    debug: false,
  };
  return new Promise((resolve, reject) => {
    http
      .get('/cfmotoservervehicle/user/vehicle/poster/jssdk-sign', {
        params: {
          url: href.split('#')[0],
        },
      })
      .then((resData) => {
        const { debug, appId, timestamp, nonceStr, signature } = Object.assign(defaults, options, resData.data);
        const config = {
          debug: debug === 'true',
          appId,
          timestamp,
          nonceStr,
          signature,
          jsApiList: [
            'hideMenuItems',
            'updateTimelineShareData',
            'updateAppMessageShareData',
            'onMenuShareWeibo',
            'hideAllNonBaseMenuItem',
            'showMenuItems',
            'chooseWXPay',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'pauseVoice',
            'stopVoice',
            'onVoicePlayEnd',
            'uploadVoice',
            'downloadVoice',
          ],
        };
        window.wx.config(config);

        window.wx.error((res) => {
          console.log(res);
          if (debug === 'true') {
            alert(`error:${JSON.stringify(res)}`);
          }
          reject();
        });
        window.wx.ready((res) => {
          window.wx.hideMenuItems({
            menuList: ['menuItem:copyUrl', 'menuItem:openWithQQBrowser', 'menuItem:openWithSafari'], // 要隐藏的菜单项，所有menu项见附录3
          });
          resolve(res);
        });
      });
  });
};

// 分享
export const weixinShare = (options = {}) => {
  const { protocol, href } = window.location;

  const defaults = {
    title: 'CFMOTO',
    desc: '买进口正品，选CFMOTO~~',
    link: href,
    imgUrl: `${logo}`,
    dataUrl: '',
  };
  const o = { ...defaults, ...options };
  o.imgUrl = (o.imgUrl || defaults.imgUrl).replace(/^\/\//, `${protocol}//`);

  window.wx.updateTimelineShareData(o);
  window.wx.updateAppMessageShareData(o);

  window.wx.onMenuShareWeibo(o);
};

// 微信支付
export const weixinPay = ({ config, success, cancel, fail, complete }) => {
  window.wx.config({
    debug: config.debug === 'true',
    appId: config.appid || config.appId,
    jsApiList: ['chooseWXPay'],
  });

  const params = {
    appId: config.appid || config.appId,
    timestamp: config.timeStamp || config.timestamp,
    nonceStr: config.nonceStr || config.noncestr,
    // package: config.package,
    package: `prepay_id=${/package=([\d]+)/.exec(config.mwebUrl)[0].split('=')[1]}`,
    // package: config.package || `prepay_id=${config.prepay_id}`,
    signType: config.signType || 'MD5',
    paySign: config.paySign || config.sign,
  };
  console.log('打印');
  console.log(params);
  return new Promise((resolve) => {
    window.wx.ready(() => {
      window.wx.chooseWXPay({
        appId: config.appid || config.appId,
        timestamp: config.timeStamp || config.timestamp,
        nonceStr: config.nonceStr || config.noncestr,
        // package: config.package,
        package: `prepay_id=${/package=([\d]+)/.exec(config.mwebUrl)[0].split('=')[1]}`,
        // package: config.package || `prepay_id=${config.prepay_id}`,
        signType: config.signType || 'MD5',
        paySign: config.paySign || config.sign,
        fail(res) {
          console.log(res);
          if (complete) {
            complete();
          }
          if (fail) {
            fail(res);
          }
          resolve(res);
        },
        success(res) {
          if (complete) {
            complete();
          }
          if (success) {
            success(res);
          }
          resolve(res);
        },
        cancel(res) {
          if (complete) {
            complete();
          }
          if (cancel) {
            cancel(res);
          }
          resolve(res);
        },
      });
    });
  });
};

// 微信授权

export const weixinAuthoritionApi = (params) => {
  window.location.href = `${baseURL}/cfmotoservervehicle/app/official/account/authorize?redirectUri=${encodeURIComponent(params.redirectUri)}`;
};

/**
 * 获取用户信息
 */
export const userGetinfoApi = (params, config) => {
  const token = postToken() || JSON.parse(localStorage.getItem('token') || '""');
  return http.get('/cfmotoservermall/api/finance/user', { params: { ...params, token }, ...config });
};
export const appletUserInfo = (params, config) => http.get('/cfmotoservermall/applet/user/info', { params, ...config });
export const vehicleMineApi = (params, config) => http.get('/cfmotoservervehicle/app/vehicle/mine?position=1', { params, ...config });
// 搜索用户
export const friendAddGetApi = (params, config = {}) => http.get('/cfmotoserverim/app/friend/add/get', { params, ...config });
// 阿里云视频授权
export const sysOssPlayAuthApi = (params, config) => http.get('/jv/sys/oss/play_auth/', { params, ...config });

// 发送短信验证码-询价
export const appUserInquiryPriceSendApi = (params, config) => http.get('/cfmotoservermall/app/user/inquiry/price/send/verify', { params, ...config });
export const appUserInquiryPriceVerifyApi = (params, config) => http.get('/cfmotoservermall/app/user/inquiry/price/verify/verify', { params, ...config });

// 数据埋点
export const appPointSendApi = (params, config) => {
  const token = postToken() || JSON.parse(localStorage.getItem('token') || '""');
  if (!token) return '';
  return http.post('/cfmotoservermall/app/dbpoint/send', params, { ...config });
};

// 二维码生成
export const openToolsQrcodeApi = (params, config = {}) => http.get('/api-open/tools/qrcode', { params, responseType: 'blob', ...config });
/**
 * 记录错误日志
 */
export const siteLoggerApi = (params, config) => ({ params, ...config });
// http.post('/site/logger', params, { ...config })
// );

export const appCodeApi = (params, config = {}) => http.get('/cfmotoservermall/app/code', { params, ...config });
export const appCodeListApi = (params, config = {}) => http.get('/cfmotoservermall/app/code/list', { params, ...config });
// // 阿里云oss上传-
export const fileUploadAliossApi = async (params, config = {}) => {
  const file = params.file;
  // 项目oss签名
  const resData = await http.get(`/api-open/configure/oss-sign`, { params: { projectName: 'CFMOTO_H5', dir: params.dir }, ...config });

  const { dir, host, ossAccessKeyId, policy, signature } = resData.data || {};
  const fileTypeStart = file.name.lastIndexOf('.');
  const fileType = file.name.slice(fileTypeStart);
  const name = new Date().getTime() + fileType;
  const key = `${dir}${name}`;

  const formData = new FormData();
  formData.append('key', key);
  formData.append('policy', policy);
  formData.append('OSSAccessKeyId', ossAccessKeyId);
  formData.append('signature', signature);
  formData.append('success_action_status', '200');
  formData.append('file', file); // 必须写在最后一个

  const instance = axios.create({ timeout: 30 * 60 * 1000 });

  const res = await instance.post(host, formData, { ...config, headers: { 'Content-Type': 'multipart/form-data' } });
  const data = res.data || {};
  data.url = `${host}/${key}`;
  return data;
};

export const replaceHost = (url) => {
  const ossPath = 'https://cfmoto.oss-cn-hangzhou.aliyuncs.com/';
  const cdnPath = 'https://oss-cfmoto.zeehoev.com/';
  return url.replace(/^http:/, 'https:').replace(ossPath, cdnPath);
};

// export const fileUploadAliossApi = async (params, config = {}) => {
//   const file = params.file;
//   const fileName = `${getFileNumber()}${getFileSuffix(file.name)}`;
//   const uploadUrl = `${getUploadDir()}/${params.dir}/${fileName}`;
//   const res = await new OSSClient().multipartUpload(uploadUrl, file, {
//     progress: (percent) => {
//       if (config.onUploadProgress) {
//         const progressEvent = { lengthComputable: true, loaded: file.size * percent, total: file.size };
//         config.onUploadProgress(progressEvent);
//       }
//       // options.onProgress({ percent: percent * 100 });
//     },
//   });
//   res.res.url = res.res.requestUrls[0].split('?')[0];
//   return res.res;
// };
